var _regeneratorRuntime = require("@babel/runtime/regenerator");

module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/index.ts");
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  "../../node_modules/webpack/buildin/global.js":
  /***/
  function node_modulesWebpackBuildinGlobalJs(module, exports) {
    var g; // This works in non-strict mode

    g = function () {
      return this;
    }();

    try {
      // This works if eval is allowed (see CSP)
      g = g || new Function("return this")();
    } catch (e) {
      // This works if the window reference is available
      if (typeof window === "object") g = window;
    } // g can still be undefined, but nothing to do about it...
    // We return undefined, instead of nothing here, so it's
    // easier to handle this case. if(!global) { ...}


    module.exports = g;
    /***/
  },

  /***/
  "./src/index.ts":
  /***/
  function srcIndexTs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: external "react"


    var external_react_ = __webpack_require__("react");

    var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_); // EXTERNAL MODULE: external "p-queue"


    var external_p_queue_ = __webpack_require__("p-queue");

    var external_p_queue_default = /*#__PURE__*/__webpack_require__.n(external_p_queue_); // CONCATENATED MODULE: ./src/helpers.ts


    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function _asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    var queue = new external_p_queue_default.a({
      concurrency: 1
    });

    var wait = function wait(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    };

    function log(label) {
      var _console;

      for (var _len = arguments.length, restOfArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        restOfArgs[_key - 1] = arguments[_key];
      } // eslint-disable-next-line no-console


      (_console = console).log.apply(_console, ["%c" + (label || '[event]'), 'border-radius: 3px; color: white; font-weight: bold; font-size: 15px; font-face: Helvetica; background-color: #00aed9; border: 1px solid #fbf2de; text-shadow: 1px 1px 4px #757989; padding: 4px 8px;'].concat(restOfArgs));
    }

    var sendToClients = function sendToClients(clients) {
      return clients.filter(function (x) {
        return !['debug', 'noPublish', 'history'].includes(x);
      });
    };

    var trackerAsync = function trackerAsync(configs) {
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type, eventName, eventData, clients, props) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (eventData === void 0) {
                    eventData = {};
                  }

                  return _context2.abrupt("return", Promise.all(sendToClients(clients || Object.keys(configs)).map( /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
                      var trackerClient, data;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              trackerClient = configs[client] || {};
                              data = (eventData || {})[client];
                              return _context.abrupt("return", trackerClient[type](eventName, data, configs.debug && log, configs.noPublish, props));

                            case 3:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x6) {
                      return _ref2.apply(this, arguments);
                    };
                  }())));

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x, _x2, _x3, _x4, _x5) {
          return _ref.apply(this, arguments);
        };
      }();
    };

    var tracker = function tracker(configs) {
      return function (type, eventName, eventData, clients, props) {
        if (eventData === void 0) {
          eventData = {};
        }

        sendToClients(clients || Object.keys(configs)).forEach(function (client) {
          var trackerClient = configs[client] || {};

          if (typeof trackerClient[type] === 'function') {
            var data = (eventData || {})[client];
            queue.add(function () {
              return wait(200).then(trackerClient[type](eventName, data, configs.debug && log, configs.noPublish, props));
            });
          }
        });
      };
    }; // CONCATENATED MODULE: ./src/Provider.tsx


    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }

    function Provider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function Provider_asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            Provider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            Provider_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    var AnalyticsContext = external_react_default.a.createContext({
      analytics: {}
    });

    var Provider_AnalyticsProvider = function AnalyticsProvider(props) {
      var configs = props.configs;
      var track = tracker(configs);
      var trackAsync = trackerAsync(configs);

      var methods = _extends({}, ['trackEvent', 'trackEventAsync', 'trackConversion', 'trackUser', 'trackException', 'trackMetric', 'trackPageView'].reduce(function (acc, funcName) {
        acc[funcName] = /*#__PURE__*/function () {
          var _ref = Provider_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(eventName, eventData, clients) {
            var _len,
                args,
                _key,
                _args = arguments;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    for (_len = _args.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
                      args[_key - 3] = _args[_key];
                    }

                    return _context.abrupt("return", funcName.includes('Async') ? trackAsync(funcName, eventName, eventData, clients, args) : track(funcName, eventName, eventData, clients, args));

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x, _x2, _x3) {
            return _ref.apply(this, arguments);
          };
        }();

        return acc;
      }, {}));

      var children = props.children,
          rest = _objectWithoutPropertiesLoose(props, ["children"]);

      return external_react_default.a.createElement(AnalyticsContext.Provider, {
        value: {
          analytics: _extends({}, methods, {}, rest)
        }
      }, children);
    };
    /* harmony default export */


    var Provider = Provider_AnalyticsProvider; // CONCATENATED MODULE: ./src/scripts/base.ts

    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      subClass.__proto__ = superClass;
    }

    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;

      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;

        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }

        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);

          _cache.set(Class, Wrapper);
        }

        function Wrapper() {
          return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }

        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };

      return _wrapNativeSuper(Class);
    }

    function isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;

      try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }

    function _construct(Parent, args, Class) {
      if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }

      return _construct.apply(null, arguments);
    }

    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }
    /* eslint-disable @typescript-eslint/interface-name-prefix, @typescript-eslint/no-unused-vars */


    var AnalyticsClientError = /*#__PURE__*/function (_Error) {
      _inheritsLoose(AnalyticsClientError, _Error);

      function AnalyticsClientError() {
        return _Error.apply(this, arguments) || this;
      }

      return AnalyticsClientError;
    }(_wrapNativeSuper(Error));

    var BaseClient = function BaseClient(_name, config) {
      var _this = this;

      this.name = void 0;
      this.config = void 0;

      this.trackConversion = function () {
        _this.methodDoesntExist('trackConversion');
      };

      this.trackEvent = function () {
        _this.methodDoesntExist('trackEvent');
      };

      this.trackUser = function () {
        _this.methodDoesntExist('trackUser');
      };

      this.trackException = function () {
        _this.methodDoesntExist('trackException');
      };

      this.trackMetric = function () {
        _this.methodDoesntExist('trackMetric');
      };

      this.methodDoesntExist = function (name) {
        if (true) {
          return null;
        }

        throw new AnalyticsClientError(name + " not implemented");
      };

      this.name = _name;
      this.config = config;
    }; // CONCATENATED MODULE: ./src/middleware.ts


    function middleware_objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }

    var checkForTrackerAndName = function checkForTrackerAndName(analytic) {
      var trackerType = analytic.type,
          name = analytic.name;

      if (!trackerType || !name) {
        // eslint-disable-next-line no-console
        console.warn('Missing type and/or name for this dispatched action');
        return false;
      }

      return analytic;
    };

    var getListOfValidAnalyticsToCall = function getListOfValidAnalyticsToCall(analytics) {
      var isArray = Array.isArray(analytics);
      if (isArray) return analytics.map(checkForTrackerAndName).filter(Boolean);
      return [checkForTrackerAndName(analytics)].filter(Boolean);
    };

    var middleware_getAllClients = function getAllClients(configs) {
      return Object.keys(configs).map(function (x) {
        return configs[x] instanceof BaseClient ? x : false;
      }).filter(Boolean);
    };

    var middleware_middleware = function middleware(configs) {
      var track = tracker(configs);
      var allDefaultClients = middleware_getAllClients(configs);
      return function (store) {
        return function (next) {
          return function (action) {
            var dispatch = store.dispatch;
            var type = action.type,
                meta = action.meta;
            var isLoadingOrErrorAction = /(LOADING|ERROR)$/i.test(type);
            next(action);
            if (!meta || !meta.analytics || isLoadingOrErrorAction) return;
            getListOfValidAnalyticsToCall(meta.analytics).forEach(function (analytic) {
              var trackerType = analytic.type,
                  name = analytic.name,
                  clients = analytic.clients,
                  theRestIsEventData = middleware_objectWithoutPropertiesLoose(analytic, ["type", "name", "clients"]); // TODO: not too happy with this...

              (clients || allDefaultClients).forEach(function (analyticType) {
                var eventName = "@@analytics/ANALYTICS_" + analyticType.toUpperCase() + "_" + (trackerType || '').toUpperCase();
                dispatch({
                  type: eventName,
                  payload: theRestIsEventData[analyticType]
                });
              });
              track(trackerType, name, theRestIsEventData, clients);
            });
          };
        };
      };
    };
    /* harmony default export */


    var src_middleware = middleware_middleware; // EXTERNAL MODULE: external "events"

    var external_events_ = __webpack_require__("events"); // CONCATENATED MODULE: ./src/idleTimer.ts


    function idleTimer_extends() {
      idleTimer_extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return idleTimer_extends.apply(this, arguments);
    }

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }

    function idleTimer_inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      subClass.__proto__ = superClass;
    }
    /* eslint-disable @typescript-eslint/no-this-alias, @typescript-eslint/explicit-function-return-type  */
    //! this might not work correctly because of this??


    function throttle(func, limit) {
      var _this = this;

      var inThrottle;
      return function () {
        var context = _this;

        if (!inThrottle) {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          func.apply(context, args);
          inThrottle = true;
          setTimeout(function () {
            inThrottle = false;
          }, limit);
        }
      };
    }

    var IdleTimer = /*#__PURE__*/function (_EventEmitter) {
      idleTimer_inheritsLoose(IdleTimer, _EventEmitter);

      function IdleTimer(options) {
        var _this2;

        _this2 = _EventEmitter.call(this) || this;
        _this2.options = void 0;
        _this2.totalIdleTime = void 0;
        _this2.idleStart = void 0;
        _this2.event = void 0;
        _this2.timer = void 0;

        _this2.handleEvent = function () {
          if (_this2.idleStart) {
            _this2.totalIdleTime += Date.now() - _this2.idleStart;
          }

          _this2.reset();

          _this2.emit('active');

          _this2.start();
        };

        _this2.options = idleTimer_extends({
          timeout: 5000,
          throttle: 500,
          events: ['mousemove', 'mousedown', 'mousewheel', 'wheel', 'keydown', 'touchstart', 'touchmove', 'scroll', // 'onclick',
          'DOMMouseScroll']
        }, options);
        _this2.totalIdleTime = 0;
        _this2.idleStart = null;
        _this2.event = throttle(_this2.handleEvent, _this2.options.throttle || 0);

        _this2.attachEvents();

        return _this2;
      }

      var _proto = IdleTimer.prototype;

      _proto.attachEvents = function attachEvents() {
        var _this3 = this;

        if (this.options.events) this.options.events.forEach(function (event) {
          window.addEventListener(event, _this3.event, {
            passive: true
          });
        });
      };

      _proto.removeEvents = function removeEvents(events) {
        var _this4 = this;

        if (events === void 0) {
          events = this.options.events;
        }

        if (events) events.forEach(function (event) {
          window.removeEventListener(event, _this4.event, {
            passive: true
          });
        });
      };

      _proto.start = function start() {
        var _this5 = this;

        if (this.timer) return;
        this.timer = setTimeout(function () {
          _this5.emit('idle');

          _this5.idleStart = Date.now();
        }, this.options.timeout);
        this.emit('start');
      };

      _proto.reset = function reset() {
        clearTimeout(this.timer);
        this.timer = null;
        this.idleStart = null;
      };

      _proto.stop = function stop() {
        this.reset();
        this.removeEvents();
        this.emit('stop');
      };

      _createClass(IdleTimer, [{
        key: "idleTime",
        get: function get() {
          return this.totalIdleTime;
        }
      }]);

      return IdleTimer;
    }(external_events_["EventEmitter"]);
    /* harmony default export */


    var idleTimer = IdleTimer; // if you want to what the timer is doing, you can add the following events wherever you declared timer:
    // this.timer.on('start', () => {
    //   console.warn(
    //     `[${this.componentName}] timer started`
    //   );
    // });
    // this.timer.on('stop', () => {
    //   console.warn(
    //     `[${this.componentName}] timer stopped`
    //   );
    // });
    // this.timer.on('idle', () => {
    //   console.warn(
    //     `[${
    //       this.componentName
    //     }] user became idle`
    //   );
    // });
    // this.timer.on('active', () => {
    //   console.warn(
    //     `[${
    //       this.componentName
    //     }] user became active`
    //   );
    // });
    // CONCATENATED MODULE: ./src/withAnalytics.tsx

    function withAnalytics_extends() {
      withAnalytics_extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return withAnalytics_extends.apply(this, arguments);
    }

    function withAnalytics_inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      subClass.__proto__ = superClass;
    }

    var withAnalytics_withAnalytics = function withAnalytics(_ref) {
      var componentName = _ref.componentName,
          enableComponentTracking = _ref.enableComponentTracking,
          timerOptions = _ref.timerOptions;
      return function (WrappedComponent) {
        var _class, _temp;

        return _temp = _class = /*#__PURE__*/function (_PureComponent) {
          withAnalytics_inheritsLoose(_class, _PureComponent);

          function _class() {
            var _this;

            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
            _this.componentName = '';
            _this.timer = void 0;
            _this.componentDidMountTimestamp = 0;

            _this.sendMetrics = function () {
              var configs = _this.context.analytics.configs;
              var track = tracker(configs);
              var average = (Date.now() - _this.componentDidMountTimestamp - _this.timer.idleTime) / 1000;
              if (average > 1) track('trackMetric', 'React Component Engaged Time (seconds)', {
                appinsights: {
                  'Component Name': _this.componentName,
                  average: average
                }
              }, ['appinsights']);
            };

            return _this;
          }

          var _proto = _class.prototype;

          _proto.componentDidMount = function componentDidMount() {
            if (enableComponentTracking) {
              this.componentName = componentName || WrappedComponent.prototype.constructor.name;
              this.timer = new idleTimer(timerOptions);
              this.timer.start();
              this.componentDidMountTimestamp = Date.now();
              window.addEventListener('beforeunload', this.sendMetrics);
            }
          };

          _proto.componentWillUnmount = function componentWillUnmount() {
            if (enableComponentTracking) {
              this.sendMetrics();
              window.removeEventListener('beforeunload', this.sendMetrics);
              this.timer.stop();
              this.timer = null;
            }
          };

          _proto.render = function render() {
            var _this2 = this;

            return external_react_default.a.createElement(AnalyticsContext.Consumer, null, function (context) {
              return external_react_default.a.createElement(WrappedComponent, withAnalytics_extends({}, _this2.props, context));
            });
          };

          return _class;
        }(external_react_["PureComponent"]), _class.contextType = AnalyticsContext, _temp;
      };
    };
    /* harmony default export */


    var src_withAnalytics = withAnalytics_withAnalytics; // CONCATENATED MODULE: ./src/config.ts

    var ConfigImplementation = function ConfigImplementation(config) {
      this.config = config;
      this.config = config;
      return this.config;
    };

    var CreateConfig = ConfigImplementation;
    /* harmony default export */

    var config = CreateConfig; // CONCATENATED MODULE: ./src/useAnalytics.ts

    var useAnalytics_useAnalytics = function useAnalytics() {
      var _useContext = Object(external_react_["useContext"])(AnalyticsContext),
          analytics = _useContext.analytics;

      return analytics;
    };
    /* harmony default export */


    var src_useAnalytics = useAnalytics_useAnalytics; // EXTERNAL MODULE: ./src/scripts/helpers.ts

    var helpers = __webpack_require__("./src/scripts/helpers.ts"); // CONCATENATED MODULE: ./src/index.ts

    /* concated harmony reexport Provider */


    __webpack_require__.d(__webpack_exports__, "Provider", function () {
      return Provider;
    });
    /* concated harmony reexport withAnalytics */


    __webpack_require__.d(__webpack_exports__, "withAnalytics", function () {
      return src_withAnalytics;
    });
    /* concated harmony reexport CreateConfig */


    __webpack_require__.d(__webpack_exports__, "CreateConfig", function () {
      return config;
    });
    /* concated harmony reexport middleware */


    __webpack_require__.d(__webpack_exports__, "middleware", function () {
      return src_middleware;
    });
    /* concated harmony reexport useAnalytics */


    __webpack_require__.d(__webpack_exports__, "useAnalytics", function () {
      return src_useAnalytics;
    });
    /* concated harmony reexport AnalyticsContext */


    __webpack_require__.d(__webpack_exports__, "AnalyticsContext", function () {
      return AnalyticsContext;
    });
    /* concated harmony reexport isServer */


    __webpack_require__.d(__webpack_exports__, "isServer", function () {
      return helpers["i"
      /* isServer */
      ];
    });
    /* concated harmony reexport setGlobal */


    __webpack_require__.d(__webpack_exports__, "setGlobal", function () {
      return helpers["k"
      /* setGlobal */
      ];
    });
    /* concated harmony reexport getGlobal */


    __webpack_require__.d(__webpack_exports__, "getGlobal", function () {
      return helpers["g"
      /* getGlobal */
      ];
    });
    /* concated harmony reexport getCookie */


    __webpack_require__.d(__webpack_exports__, "getCookie", function () {
      return helpers["e"
      /* getCookie */
      ];
    });
    /* concated harmony reexport getOsName */


    __webpack_require__.d(__webpack_exports__, "getOsName", function () {
      return helpers["h"
      /* getOsName */
      ];
    });
    /* concated harmony reexport getBrowserName */


    __webpack_require__.d(__webpack_exports__, "getBrowserName", function () {
      return helpers["c"
      /* getBrowserName */
      ];
    });
    /* concated harmony reexport loadExternalScript */


    __webpack_require__.d(__webpack_exports__, "loadExternalScript", function () {
      return helpers["j"
      /* loadExternalScript */
      ];
    });
    /* concated harmony reexport getExternalScriptClient */


    __webpack_require__.d(__webpack_exports__, "getExternalScriptClient", function () {
      return helpers["f"
      /* getExternalScriptClient */
      ];
    });
    /* concated harmony reexport getAnalyticsClient */


    __webpack_require__.d(__webpack_exports__, "getAnalyticsClient", function () {
      return helpers["b"
      /* getAnalyticsClient */
      ];
    });
    /* concated harmony reexport getClientProperties */


    __webpack_require__.d(__webpack_exports__, "getClientProperties", function () {
      return helpers["d"
      /* getClientProperties */
      ];
    });
    /* concated harmony reexport appendQueryParamToUrl */


    __webpack_require__.d(__webpack_exports__, "appendQueryParamToUrl", function () {
      return helpers["a"
      /* appendQueryParamToUrl */
      ];
    });
    /* concated harmony reexport log */


    __webpack_require__.d(__webpack_exports__, "log", function () {
      return log;
    });
    /* concated harmony reexport tracker */


    __webpack_require__.d(__webpack_exports__, "tracker", function () {
      return tracker;
    });
    /* concated harmony reexport trackerAsync */


    __webpack_require__.d(__webpack_exports__, "trackerAsync", function () {
      return trackerAsync;
    });
    /* concated harmony reexport BaseClient */


    __webpack_require__.d(__webpack_exports__, "BaseClient", function () {
      return BaseClient;
    });
    /* concated harmony reexport LooseObject */


    __webpack_require__.d(__webpack_exports__, "LooseObject", function () {
      return (
        /* Cannot get final name for export "LooseObject" in "./src/scripts/base.ts" (known exports: default, known reexports: ) */
        undefined
      );
    });
    /***/

  },

  /***/
  "./src/scripts/helpers.ts":
  /***/
  function srcScriptsHelpersTs(module, __webpack_exports__, __webpack_require__) {
    "use strict";
    /* WEBPACK VAR INJECTION */

    (function (global) {
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "i", function () {
        return isServer;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "k", function () {
        return setGlobal;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "g", function () {
        return getGlobal;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "e", function () {
        return getCookie;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "h", function () {
        return getOsName;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return getBrowserName;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "j", function () {
        return loadExternalScript;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "f", function () {
        return getExternalScriptClient;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return getAnalyticsClient;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return getClientProperties;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return appendQueryParamToUrl;
      });
      /* harmony import */


      var _wurfl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/scripts/wurfl.ts");

      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }

      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
              args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);

            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }

            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }

            _next(undefined);
          });
        };
      }

      var isServer = typeof window === 'undefined';

      var noop = function noop() {
        return undefined;
      };

      function getGlobal(globalProp) {
        if (isServer) {
          if (typeof global !== 'undefined') {
            return global[globalProp];
          }

          return undefined;
        }

        return window[globalProp];
      }

      function getCookie(cookieName) {
        if (isServer) return undefined;
        var cookie = (document.cookie.split('; ').map(function (str) {
          return str.split('=');
        }).find(function (_ref) {
          var name = _ref[0];
          return name === cookieName;
        }) || [])[1];

        if (cookie !== undefined) {
          return cookie.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
        }

        return cookie;
      }

      function getOsName() {
        if (isServer) return '';

        if (window.navigator.appVersion.indexOf('Win') !== -1) {
          return 'Windows';
        }

        if (window.navigator.appVersion.indexOf('Mac') !== -1) {
          return 'MacOS';
        }

        if (window.navigator.appVersion.indexOf('X11') !== -1) {
          return 'UNIX';
        }

        if (window.navigator.appVersion.indexOf('Linux') !== -1) {
          return 'Linux';
        }

        return 'Unknown OS';
      }

      function getBrowserName() {
        if (isServer) return '';
        var useragent = window.navigator.userAgent;
        var revision = null;
        var matchedName = useragent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

        if (/trident/i.test(matchedName[1])) {
          revision = /\brv[ :]+(\d+)/g.exec(useragent) || [];
          return "IE " + (revision[1] || '');
        }

        if (matchedName[1] === 'Chrome') {
          revision = useragent.match(/\bOPR\/(\d+)/);

          if (revision !== null) {
            return "Opera " + revision[1];
          }
        }

        matchedName = matchedName[2] ? [matchedName[1], matchedName[2]] : [window.navigator.appName, window.navigator.appVersion, '-?'];
        revision = useragent.match(/version\/(\d+)/i);

        if (revision !== null) {
          matchedName.splice(1, 1, revision[1]);
        }

        return matchedName.join(' ');
      }

      function getClientProperties() {
        return _getClientProperties.apply(this, arguments);
      }

      function _getClientProperties() {
        _getClientProperties = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var WURFL;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!isServer) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return", {});

                case 2:
                  _context2.next = 4;
                  return Object(_wurfl__WEBPACK_IMPORTED_MODULE_0__[
                  /* default */
                  "a"])();

                case 4:
                  WURFL = _context2.sent;
                  return _context2.abrupt("return", {
                    browser: getBrowserName(),
                    os: getOsName(),
                    deviceCategory: WURFL && WURFL.form_factor,
                    deviceName: WURFL && WURFL.complete_device_name,
                    referrer: document.referrer,
                    language: navigator.language,
                    screenResolution: window.screen.width + "x" + window.screen.height,
                    browserResolution: window.innerWidth + "x" + window.innerHeight,
                    url: window.location.href
                  });

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return _getClientProperties.apply(this, arguments);
      }

      function setGlobal(key, val) {
        if (isServer) return;
        window[key] = val; // eslint-disable-next-line consistent-return

        return window[key];
      }

      function loadExternalScript(url, globalProp, callback) {
        if (callback === void 0) {
          callback = noop;
        }

        return new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.async = true;
          script.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var result;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return callback(window[globalProp]);

                  case 2:
                    result = _context.sent;

                    if (!window[globalProp]) {
                      setGlobal(globalProp, result);
                    }

                    resolve(window[globalProp]);

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          script.onerror = reject;
          script.src = url;
          document.body.appendChild(script);
        });
      }

      var getExternalScriptClient = function getExternalScriptClient(globalProp, url, callback) {
        if (callback === void 0) {
          callback = noop;
        }

        if (!globalProp || isServer) {
          return undefined;
        }

        if (url && !window[globalProp]) {
          return loadExternalScript(url, globalProp, callback).catch(function () {
            console.error("unable to load " + url + " script");
            return null;
          });
        }

        callback(window[globalProp]);
        return window[globalProp];
      };

      function getAnalyticsClient(globalProp, url, callback) {
        if (callback === void 0) {
          callback = noop;
        }

        return getExternalScriptClient(globalProp, url, callback);
      }

      function appendQueryParamToUrl(url, param, value) {
        if (url === void 0) {
          url = '';
        }

        var operator = url.includes('?') ? '&' : '?';
        return "" + url + operator + param + "=" + value;
      }
      /* WEBPACK VAR INJECTION */

    }).call(this, __webpack_require__("../../node_modules/webpack/buildin/global.js"));
    /***/
  },

  /***/
  "./src/scripts/wurfl.ts":
  /***/
  function srcScriptsWurflTs(module, __webpack_exports__, __webpack_require__) {
    "use strict";
    /* harmony export (binding) */

    __webpack_require__.d(__webpack_exports__, "a", function () {
      return getWurflClient;
    });
    /* harmony import */


    var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/scripts/helpers.ts");

    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function _asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    function getWurflClient() {
      return _getWurflClient.apply(this, arguments);
    }

    function _getWurflClient() {
      _getWurflClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var client;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(_helpers__WEBPACK_IMPORTED_MODULE_0__[
                /* getAnalyticsClient */
                "b"])('WURFL', '//wurfl.io/wurfl.js');

              case 2:
                client = _context.sent;

                if (client) {
                  _context.next = 7;
                  break;
                }

                _context.next = 6;
                return Object(_helpers__WEBPACK_IMPORTED_MODULE_0__[
                /* getAnalyticsClient */
                "b"])('WURFL', "//wurfl.io/wurfl.js");

              case 6:
                client = _context.sent;

              case 7:
                return _context.abrupt("return", client);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getWurflClient.apply(this, arguments);
    }
    /***/

  },

  /***/
  "events":
  /***/
  function events(module, exports) {
    module.exports = require("events");
    /***/
  },

  /***/
  "p-queue":
  /***/
  function pQueue(module, exports) {
    module.exports = require("p-queue");
    /***/
  },

  /***/
  "react":
  /***/
  function react(module, exports) {
    module.exports = require("react");
    /***/
  }
  /******/

});